import React, { Component } from 'react';
import { Grid, Row, Col, Table, FormGroup, FormControl, ButtonToolbar, Button, OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap';
import Select from "react-select";
import { CustomColorPicker } from '../../CustomColorPicker';

import { FontStyleCommand } from '../../commands/FontStyleCommand';
import { HandleMessage } from '../../../HandleMessage';
import { HandleDialog } from '../../../HandleDialog';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { FontStyleFormatHelper } from '../../helpers/FontStyleFormatHelper';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { ColorDisplayer } from '../../../ColorDisplayer';
import { TableButton } from '../../../TableButton';

export class FontStyles extends Component {
    constructor(props) {
        super(props);

        this.nextInternalId = 1;
        this.updatingStyle = false;

        this.state = {
            fontsAvailable: {
                data: [],
                loading: true
            },
            formStyles: {
                target: null,
                fontFamily: null,
                fontSize: null,
                textAnchor: null
            },
            formData: {
                id: 0,
                internalId: 0,
                target: this.props.targets.data[0],
                fontFamily: "",
                fontSize: 0,
                textAnchor: 1,
                fillColor: "black",
                strokeColor: "black"
            },
            table: {
                data: this.props.data.map(style => Object.assign({ internalId: this.nextInternalId++ }, style)),
                page: 1,
                elementsPerPage: 10
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            actions: {
                isLoadingFonts: true
            }
        }

        this.getAvailableFonts(false);
    }

    getAvailableFonts(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingFonts = true;

            this.setState({
                fontsAvailable: {
                    data: [],
                    loading: true
                },
                actions: actions
            });
        }

        const fontStyleCommand = new FontStyleCommand();
        fontStyleCommand.getAvailableFonts(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    successCallback(result) {
        const { fontsAvailable, formData, actions } = this.state;

        formData.fontFamily = 0 === result.length ? "" : result[0].name;
        fontsAvailable.data = result;
        actions.isLoadingFonts = false;

        // Update table
        this.setState({
            formData: formData,
            fontsAvailable: fontsAvailable,
            actions: actions
        });
    }

    errorCallback(message) {
        const { fontsAvailable, actions } = this.state;

        actions.isLoadingFonts = false;
        fontsAvailable.data = [];

        this.setState({
            fontsAvailable: fontsAvailable,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    componentWillReceiveProps(nextProps) {
        const { targets } = nextProps;

        if (!this.updatingStyle) {
            const { formData } = this.state;

            formData.target = targets.data[0];
            this.setState({
                formData: formData
            });
        }

        this.updatingStyle = false;
    }

    // -----------------------

    removeUnunecessaryProperties(style) {
        const modifiedStyle = Object.assign({}, style);
        delete modifiedStyle.internalId;
        return modifiedStyle;
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;

        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onChangeValue(e, target) {
        const { formData } = this.state;
        formData[target] = e.target.value;

        this.setState({
            formData: formData
        });
    }

    onSelectValue(e, target) {
        const { formData } = this.state;

        formData[target] = null === e ? "" : e;

        this.setState({
            formData: formData
        });
    }

    // -----------------------

    onChangeComplete(color, target) {
        if (undefined === color) {
            return;
        }

        const { formData } = this.state;

        if (("fillColor" === target || "strokeColor" === target) && "useLineColor" === color) {
            formData[target] = color;
        }
        else {
            formData[target] = color.hex;
        }

        this.setState({
            formData: formData
        });
    }

    // -----------------------

    onSaveStyle(style) {
        let formStyles = {
            target: null,
            fontFamily: null,
            fontSize: null,
            textAnchor: null,
            fillColor: null,
            strokeColor: null,
        }

        if (0 >= style.target.length) {
            formStyles.target = "error"
        }
        if (0 >= style.fontFamily.length) {
            formStyles.fontFamily = "error"
        }
        if (0 >= style.fontSize.length || 0 >= style.fontSize || 360 < style.fontSize) {
            formStyles.fontSize = "error"
        }
        if (0 >= style.textAnchor.length) {
            formStyles.textAnchor = "error"
        }
        if (0 >= style.fillColor.length) {
            formStyles.fillColor = "error"
        }
        if (0 >= style.strokeColor.length) {
            formStyles.strokeColor = "error"
        }

        this.setState({
            formStyles: formStyles
        });

        if (null === formStyles.target && null === formStyles.fontFamily && null === formStyles.fontSize && null === formStyles.textAnchor && null === formStyles.fillColor && null === formStyles.strokeColor) {
            this.updateStyles(style);
        }
    }

    updateStyles(style) {
        const { targets } = this.props;
        const { table, fontsAvailable } = this.state;

        this.updatingStyle = true;

        if (0 === style.internalId) {
            const newStyle = Object.assign({}, style);
            newStyle.internalId = this.nextInternalId++;

            table.data.push(newStyle);
        }
        else {
            const unmodifiedStyle = table.data.filter(function (s) {
                return s.internalId === style.internalId;
            })[0];

            Object.assign(unmodifiedStyle, style);
        }

        this.props.onUpdateFonts(table.data.map(d => Object.assign({}, this.removeUnunecessaryProperties(d))));

        this.setState({
            table: table,
            formData: {
                id: 0,
                internalId: 0,
                target: targets.data[0],
                fontFamily: fontsAvailable.data[0].name,
                fontSize: 0,
                textAnchor: 1,
                fillColor: "black",
                strokeColor: "black"
            }
        });
    }

    onEditStyle(style) {
        this.setState({
            formData: Object.assign({}, style)
        });
    }

    onCancelEditStyle() {
        const { targets } = this.props;
        const { fontsAvailable } = this.state;

        this.setState({
            formData: {
                id: 0,
                internalId: 0,
                target: targets.data[0],
                fontFamily: fontsAvailable.data[0].name,
                fontSize: 0,
                textAnchor: 1,
                fillColor: "black",
                strokeColor: "black"
            }
        });
    }

    onDeleteStyle(style) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o tipo de letra para o elemento "${FontStyleFormatHelper.getTargetText(style.target)}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    styleInternalId: style.internalId
                }
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { table } = this.state;

        if (isToExecute) {
            table.data = table.data.filter(function (style) {
                return style.internalId !== argument.styleInternalId;
            });

            this.props.onUpdateFonts(table.data.map(d => Object.assign({}, this.removeUnunecessaryProperties(d))));
        }

        this.setState({
            table: table,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------------

    renderColorProperty(color, cursor = "default") {
        return (
            <div>
                <ColorDisplayer color={color} cursor={cursor} />
            </div>
        );
    }

    renderFormButtons(formData) {
        let formButtons = null;
        if (0 === formData.internalId) {
            formButtons = (
                <td colSpan={2}><TableButton icon="icon-plus" title="Adicionar" onClick={() => this.onSaveStyle(formData)} /></td>
            )
        }
        else {
            formButtons = [];
            formButtons.push((
                <td key="formSaveButton"><TableButton icon="icon-save" title="Guardar" onClick={() => this.onSaveStyle(formData)} /></td>
            ));
            formButtons.push((
                <td key="formCancelButton"><TableButton icon="icon-error" title="Cancelar" onClick={() => this.onCancelEditStyle()} /></td>
            ));
        }

        return formButtons;
    }

    render() {
        const { isLoadingTargets, targets } = this.props;
        const { table, fontsAvailable, actions } = this.state;

        if (isLoadingTargets || actions.isLoadingFonts) {
            return (
                <LoadingSpinner />
            );
        }

        const { formData, formStyles, message, dialog } = this.state;
        const pallet = ["#FFFFFF", "#99ff99", "#00ff00", "#669900", "#ffff00", "#ff6600", "#ff0000", "#ff8080", "#ff00ff", "#6600ff", "#9999ff", "#6666ff", "#0000ff", "#663300", "#666666", "#000000"]
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col md={12} className="styles-table">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th className="width-20p">Elemento</th>
                                        <th className="width-20p">Fonte</th>
                                        <th className="width-10p">Tamanho</th>
                                        <th className="width-10p">Alinhamento</th>
                                        <th className="width-10p">Cor Preenchimento</th>
                                        <th className="width-10p">Cor Contorno</th>
                                        <th className="width-1p">&nbsp;</th>
                                        <th className="width-1p">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((obj, idx) =>
                                            <tr key={`data-${idx}`}>
                                                <td>{FontStyleFormatHelper.getTargetText(obj.target)}</td>
                                                <td>{obj.fontFamily}</td>
                                                <td>{obj.fontSize}</td>
                                                <td><Glyphicon glyph={FontStyleFormatHelper.getTextAnchorGlyph(obj.textAnchor)} /> {FontStyleFormatHelper.getTextAnchorText(obj.textAnchor)}</td>
                                                <td className="text-align-center">{this.renderColorProperty(obj.fillColor)}</td>
                                                <td className="text-align-center">{this.renderColorProperty(obj.strokeColor)}</td>
                                                <td><TableButton icon="icon-edit" title="Editar" onClick={() => this.onEditStyle(obj)} /></td>
                                                <td><TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteStyle(obj)} /></td>
                                            </tr>
                                        )
                                    }

                                    <tr>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formTargetSelect"
                                                className="no-margin"
                                                validationState={formStyles.target} >
                                                <Select
                                                    className="custom-multiselect custom-multiselect-small"
                                                    placeholder="Elemento"
                                                    noOptionsMessage={() => "Sem Elementos Configurados"}
                                                    onChange={(e) => this.onSelectValue(e, "target")}
                                                    options={targets.data}
                                                    isMulti={false}
                                                    isClearable={true}
                                                    maxMenuHeight={200}
                                                    isOptionSelected={function (a) {
                                                        return formData.target === a;
                                                    }}
                                                    getOptionValue={value => value}
                                                    getOptionLabel={label => FontStyleFormatHelper.getTargetText(label)}
                                                    value={[formData.target]}
                                                />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formFontFamilySelect"
                                                className="no-margin"
                                                validationState={formStyles.fontFamily} >
                                                <Select
                                                    className="custom-multiselect custom-multiselect-small"
                                                    placeholder="Fonte"
                                                    noOptionsMessage={() => "Sem Fontes Configuradas"}
                                                    onChange={(e) => this.onSelectValue(null === e ? "" : e.name, "fontFamily")}
                                                    options={fontsAvailable.data}
                                                    isMulti={false}
                                                    isClearable={true}
                                                    maxMenuHeight={200}
                                                    isOptionSelected={function (a) {
                                                        return formData.fontFamily === a.name;
                                                    }}
                                                    getOptionValue={value => value.name}
                                                    getOptionLabel={label => label.name}
                                                    value={fontsAvailable.data.find(a => a.name === formData.fontFamily)}
                                                />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup
                                                bsSize="small"
                                                controlId="formFontSizeNumber"
                                                className="no-margin"
                                                validationState={formStyles.fontSize} >
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    min={0}
                                                    max={150}
                                                    placeholder="Tamanho"
                                                    value={formData.fontSize}
                                                    onChange={(e) => this.onChangeValue(e, 'fontSize')} />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <ButtonToolbar>
                                                <Button
                                                    bsSize="xsmall"
                                                    active={1 === formData.textAnchor}
                                                    onClick={() => this.onChangeValue({ target: { value: 1 } }, 'textAnchor')} >
                                                    <Glyphicon glyph={FontStyleFormatHelper.getTextAnchorGlyph(1)} />
                                                </Button>
                                                <Button
                                                    bsSize="xsmall"
                                                    active={2 === formData.textAnchor}
                                                    onClick={() => this.onChangeValue({ target: { value: 2 } }, 'textAnchor')} >
                                                    <Glyphicon glyph={FontStyleFormatHelper.getTextAnchorGlyph(2)} />
                                                </Button>
                                                <Button
                                                    bsSize="xsmall"
                                                    active={3 === formData.textAnchor}
                                                    onClick={() => this.onChangeValue({ target: { value: 3 } }, 'textAnchor')} >
                                                    <Glyphicon glyph={FontStyleFormatHelper.getTextAnchorGlyph(3)} />
                                                </Button>
                                            </ButtonToolbar>
                                        </td>
                                        <td className="text-align-center">
                                            <OverlayTrigger
                                                trigger="click"
                                                rootClose
                                                placement="bottom"
                                                overlay={
                                                    <Popover id="fillColorPopover">
                                                        <CustomColorPicker
                                                            disableAlpha={true}
                                                            color={formData.fillColor}
                                                            presetColors={pallet}
                                                            canUseLineColor={this.props.canUseLineColor}
                                                            onChange={(a) => this.onChangeComplete(a, "fillColor")}
                                                        />
                                                    </Popover>
                                                } >
                                                {this.renderColorProperty(formData.fillColor, "pointer")}
                                            </OverlayTrigger>
                                        </td>
                                        <td className="text-align-center">
                                            <OverlayTrigger
                                                trigger="click"
                                                rootClose
                                                placement="bottom"
                                                overlay={
                                                    <Popover id="strokeColorPopover">
                                                        <CustomColorPicker
                                                            disableAlpha={true}
                                                            color={formData.strokeColor}
                                                            presetColors={pallet}
                                                            canUseLineColor={this.props.canUseLineColor}
                                                            onChange={(a) => this.onChangeComplete(a, "strokeColor")}
                                                        />
                                                    </Popover>
                                                } >
                                                {this.renderColorProperty(formData.strokeColor, "pointer")}
                                            </OverlayTrigger>
                                        </td>

                                        {this.renderFormButtons(formData)}
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={table.data.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                        </Col>
                    </Row>
                </Grid>
                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />
                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentStyles/FontStyles.js